import { styled } from '@mui/system';
import { Stack, Typography } from '@mui/material';
import { theme } from './theme';

export const Paragraph = styled(Typography)(({ theme }) => ({
  textIndent: theme.spacing(10),
}));

export const ParagraphTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  textIndent: theme.spacing(10),
}));

export const OrderedListContainer = styled(Stack)(({ theme }) => ({
  ol: {
    counterReset: 'item',
  },
  li: {
    display: 'block',
  },
  'li:before': {
    content: 'counters(item, ".") ". "',
    counterIncrement: 'item',
  },
  '> ol > li:not(:first-child)': {
    marginTop: theme.spacing(2),
  },
}));
